/* eslint-disable no-console */
import {
  get, isEmpty, includes, omitBy, isNil, merge,
} from 'lodash';
import AnalyticsService from './service';
import AnalyticsEvent from '../events/event';
import { debugEnabled, placeOrderCategory } from '../index';

// docs: https://developers.facebook.com/docs/facebook-pixel/reference

export default class FacebookPixel extends AnalyticsService {
  get name() {
    return 'Facebook';
  }

  get enabled() {
    return window && window.fbq && typeof window.fbq === 'function';
  }

  get trackingId() {
    return get(window, 'TIS.analytics.facebook.pixel_tracking_id');
  }

  get fbq() {
    if (!this.enabled) {
      return () => {
      }; // does nothing if not enabled
    }

    return window.fbq;
  }

  get fbStandardMethods() {
    return [
      'AddPaymentInfo',
      'AddToCart',
      'AddToWishlist',
      'CompleteRegistration',
      'Contact',
      'CustomizeProduct',
      'Donate',
      'FindLocation',
      'InitiateCheckout',
      'Lead',
      'PageView',
      'Schedule',
      'Search',
      'StartTrial',
      'SubmitApplication',
      'ViewContent',
    ];
  }

  isStandardFbMethod(method) {
    return includes(this.fbStandardMethods, method);
  }

  _track(event) {
    if (!event instanceof AnalyticsEvent) {
      console.error('fb _track method can only receive events that are instances of AnalyticsEvent', event);
      return;
    }

    const category = get(event, 'category');

    let properties = omitBy({
      content_category: category,
      content_name: get(event, 'name'),
      content_ids: get(event, 'fbContentIds'),
    }, isNil);

    if (category === placeOrderCategory) {
      properties.content_type = 'product';
    }

    const additionalProperties = get(event, 'fbAdditionalProperties');
    if (!isEmpty(additionalProperties)) {
      properties = merge(properties, additionalProperties);
    }

    if (debugEnabled) {
      console.info(`fb tracking event: ${event.category}: ${event.name} with method: ${event.fbTrackMethod}`, properties);
    }

    this.fbq(
      this.isStandardFbMethod(event.fbTrackMethod) ? 'track' : 'trackCustom',
      event.fbTrackMethod,
      properties,
    );
  }

  reIdentify(identity) {
    const initProps = {};
    const userProps = {};

    const email = get(identity, 'email');
    const clientId = get(identity, 'clientId');

    if (!isEmpty(email)) {
      initProps.em = email;
    }
    if (!isEmpty(clientId)) {
      initProps.uid = clientId;
    }

    const accountCreatedTimestamp = get(identity, 'accountCreatedTimestamp');
    const country = get(identity, 'country');
    const currency = get(identity, 'currency');
    const language = get(identity, 'language');
    const businessCategories = get(identity, 'businessCategories');

    if (!isEmpty(accountCreatedTimestamp)) {
      userProps.$account_created_time = accountCreatedTimestamp;
    }
    if (!isEmpty(country)) {
      userProps.$country = country;
    }
    if (!isEmpty(currency)) {
      userProps.$currency = currency;
    }
    if (!isEmpty(language)) {
      userProps.$language = language;
    }
    if (!isEmpty(businessCategories)) {
      userProps.$user_type = businessCategories;
    }

    if (!isEmpty(initProps)) {
      this.fbq('init', this.trackingId, initProps);
    }

    if (!isEmpty(userProps)) {
      this.fbq('setUserProperties', this.trackingId, userProps);
    }
  }
}
